<template>
    <!-- :href="item.link" -->
    <div class="m-slider" style=" display: flex;
    flex-direction: row;" :style="`height: ${height}px; width: ${totalWidth}px;`" @mouseenter="onStop"
        @mouseleave="onStart">
        <div :style="`will-change: transform; transform: translateX(${-left}px);  width: ${width - 20}px;`"
            class="u-slide-title" v-for="(item, index) in sliderData" :key="index" :title="item.close">
            <div class="sw">
                <div class="swiperstys" @click="onClick(item.title)">
                    <div style="margin: 20px 20px ;padding-top: 20px;">
                        <div style="height: 60px;">
                            <div style="float: left;"><img style="border-radius: 50%;" :src="item.logo" alt="" width="50px">
                            </div>
                        </div>
                        <div style="height: 40px;">
                            <div style="float: left;">{{ item.symbol.split("/")[0] }}</div>
                            <div style="float: right; font-weight: 700;"
                                :style="item.chg > 0 ? 'color: #00b275;' : 'color:#f15057;'">
                                {{ item.chg > 0 ? '⇧' : '⇩' }} {{
                                    (item.chg * 100).toFixed(2) }}%</div>
                        </div>
                        <div style="height: 40px;">
                            <div style="float: left; font-size: 20px;">USDT {{ item.close }}</div>
                            <div style="float: right;"> {{ item.symbol.split("/")[1] }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'swiperText',
    props: {
        sliderData: { // 滚动文字数组
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        totalWidth: { // 滚动区域总宽度
            type: Number,
            default: 1200
        },
        height: { // 滚动区域高度
            type: Number,
            default: 45
        },
        amount: { // 滚动区域展示条数
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            left: 0,
            fpsRaf: null, // fps回调标识
            moveRaf: null, // 一个 long 整数，请求 ID ，是回调列表中唯一的标识。是个非零值，没别的意义
            start: 0,
            end: 0,
            step: 1 // 默认移动参数（120fps: 0.5, 60fps: 1）
        }
    },
    computed: {
        width() { // 滚动文字每条的固定宽度
            return Math.floor(this.totalWidth / this.amount)
        }
    },
    created() {
        this.fpsRaf = requestAnimationFrame(this.getFPS)
    },
    methods: {
        getFPS(timestamp) {
            // 单位ms，用1000ms/两个时间的间隔≈刷新频率fps
            // console.log('timestamp:', timestamp)
            if (this.fpsRaf === 2) {
                this.start = timestamp
            }
            if (this.fpsRaf === 3) {
                this.end = timestamp
                // 计算屏幕刷新率
                const fps = Math.floor(1000 / (this.end - this.start))
                if (fps === 120) {
                    this.step = 0.5
                }
                console.log('fps:', fps)
                console.log('step:', this.step)
            }
            this.fpsRaf = requestAnimationFrame(this.getFPS)
            if (this.fpsRaf > 3) {
                cancelAnimationFrame(this.fpsRaf)
                this.onStart()
            }
        },
        onClick(title) { // 通知父组件点击的标题
            // this.$emit('click', title)
            this.$router.push('/pages/trade/trade');
        },
        onStop() { // 暂停动画
            console.log('悬停2');
            this.$emit('clicks',)
            cancelAnimationFrame(this.moveRaf)
        },
        onStops() {
            cancelAnimationFrame(this.moveRaf)
        },
        onStart() { // 开始动画
            this.moveRaf = requestAnimationFrame(this.moveLeft)
            // if (this.sliderData.length > this.amount) { // 超过amount条开始滚动
            // }
        },
        moveLeft() {
            if (this.left >= this.width) {
                this.sliderData.push(this.sliderData.shift()) // 将第一条数据放到最后
                this.left = 0
            } else {
                this.left += this.step // 每次移动step（px）
            }
            this.moveRaf = requestAnimationFrame(this.moveLeft)
        }
    }
}
</script>
<style lang="scss" scoped>
.m-slider {
    margin: 0px auto;
    // background: #000000;
    // box-shadow: 0px 0px 5px #D3D3D3;
    // border-radius: 5px;
    white-space: nowrap;
    overflow: hidden;
}

.spant {
    color: #D3D3D3;
}

.u-slide-title {
    // display: inline-block;
    // margin-left: 20px;
    // font-size: 14px;
    // color: #333;
    // font-weight: 400;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // cursor: pointer;

}

.u-slide-title:hover {
    color: '#1890FF';
}

.swipersty {
    width: 18%;
    height: 180px;
    background: #2F3241;
    margin-left: 10px;
    margin-bottom: 20px;
    border-radius: 5px;
}

.sw {}

.swiperstys:hover {
    background: #000;

}

.swiperstys {
    margin-left: 10px;
    width: 350px;
    height: 180px;
    background: #2F3241;
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/swiperText.vue